var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4055 14.0709L21.7456 19.4112C22.0848 19.7505 22.0848 20.3005 21.7456 20.6398L20.6399 21.7455C20.3006 22.0848 19.7506 22.0848 19.4113 21.7455L14.0712 16.4052C13.732 16.066 13.732 15.5159 14.0712 15.1766L15.1769 14.0709C15.5162 13.7316 16.0662 13.7316 16.4055 14.0709Z",
    fill: "#2D64E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5287 7.76472C15.5287 12.0531 12.0525 15.5294 7.76437 15.5294C3.47623 15.5294 0 12.0531 0 7.76472C0 3.47638 3.47623 0 7.76437 0C12.0525 0 15.5287 3.47638 15.5287 7.76472ZM2.57626 7.76472C2.57626 10.6302 4.89905 12.9531 7.76437 12.9531C10.6297 12.9531 12.9525 10.6302 12.9525 7.76472C12.9525 4.89927 10.6297 2.57637 7.76437 2.57637C4.89905 2.57637 2.57626 4.89927 2.57626 7.76472Z",
    fill: "#2D64E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.9a24dd835b5e48406066f9df2592d394.svg";
export { ForwardRef as ReactComponent };